import safeFetch from 'shared/api/safeFetch';
import config from 'shared/config';
import { Upload, UploadItem } from 'types/uploadType';

const updateItems = (upload: Upload, newItem: UploadItem) => {
  const newItems = upload?.items?.map((item) => (item.id === newItem.id ? newItem : item));
  return { ...upload, items: newItems };
};

export function updateUploadItems(uploads: Upload[], editedItem: UploadItem): Upload[] {
  return uploads.map((upload) => (upload?.items ? updateItems(upload, editedItem) : upload));
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function uploadFile(data: unknown) {
  const url = `${config.apiUrl}/files`;
  const params = {
    body: data,
    headers: { 'Content-Type': 'multipart/form-data', access: '*/*' },
    method: 'POST',
  };
  return safeFetch(url, params);
}